import { render } from "./seo-list.vue?vue&type=template&id=1a9e4a7e"
import script from "./seo-list.vue?vue&type=script&lang=js"
export * from "./seo-list.vue?vue&type=script&lang=js"

import "./seo-list.vue?vue&type=style&index=0&id=1a9e4a7e&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__